var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 224.82,
    viewBox: "0 0 512 224.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Web_1920_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 224.82
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_1920_15",
    "data-name": "Web 1920 \\u2013 15",
    clipPath: "url(#clip-Web_1920_15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(-241.888 -386.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M4846.491-722.472l6.043-12.671s28.974-59.509,98.244-59.509,99.107,59.309,99.107,59.309l80.268,165.281h-37.326s-35.881,1.713-72.548-21.155-52.1-57.677-52.1-57.677l-28.551-58.781s-8.746-21.647-35.138-28.949-48.913,6.432-55.906,16.161a1.7,1.7,0,0,1-1.832-.212A1.592,1.592,0,0,1,4846.491-722.472Z",
    transform: "translate(-4562.25 1181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M4846.491-722.472l6.043-12.671s28.974-59.509,98.244-59.509,99.107,59.309,99.107,59.309l80.268,165.281h-37.326s-35.881,1.713-72.548-21.155-52.1-57.677-52.1-57.677l-28.551-58.781s-8.746-21.647-35.138-28.949-48.913,6.432-55.906,16.161a1.7,1.7,0,0,1-1.832-.212A1.592,1.592,0,0,1,4846.491-722.472Z",
    transform: "translate(-4376.266 1181)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 54.325,
    cy: 54.325,
    r: 54.325,
    transform: "translate(241.888 502.516)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2e8fa8c5e36c3fbb0859eecb0ea64365.svg";
export { ForwardRef as ReactComponent };